module.exports = __webpack_public_path__ + "static/media/Email.9e3ceabb.png";